export interface Product {
  id: string
  name: string
  brand: string
  brandId?: string
  brandSlug: string
  categoryId: number
  cover: string
  sku: string
  upc: string
  url: string
  visible?: boolean

  // VTO part
  colors: string[]
  coverage: string
  finish: string
  region: string
  type: string
  typeId?: string
  effectUrl?: string
  externalId?: string

  // Glasses part
  coverLeft?: Cover
  coverFront?: Cover
  coverRight?: Cover
  renderingOptions?: GlassesRenderingOptions

  // SKUs from GraphQL query
  skus?: Array<{
    id: string
    name: string
    productId: string
    sku: string
    upc?: string
    url?: string
    vto?: {
      color: string
      coverage: string
      finish: string
      region: string
      effectUrl?: string
    }
  }>
}

export type ProductV2 = Omit<Product, "colors"> & {
  file?: File
  colors: {
    color: string
    upc: string
    sku: string
    skuId?: string
    externalId?: string
    name: string
  }[]
  merchant: string
}

export interface Cover {
  lastModified: number
  name: string
  size: number
  type: string
  fileBase64: string
  width?: number
  height?: number
}

export const initRenderingOptions: GlassesRenderingOptions = {
  bodyGloss: 0.0,
  lensesGloss: 0.0,
  transparency: 0.0,
  scale: { x: 1, y: 1, z: 1 },
  positionAccuracy: { x: 0, y: 2, z: 5 },
}

export interface GlassesRenderingOptions {
  bodyGloss?: number
  lensesGloss?: number
  transparency?: number
  positionAccuracy: { x: number; y: number; z: number }
  scale: { x: number; y: number; z: number }
}

export type GlassesOptionsType<K extends keyof GlassesProduct> = {
  value: GlassesProduct[K]
  key: K
}

export type GlassesRenderingOptionsType<K extends keyof GlassesRenderingOptions> = {
  value: GlassesRenderingOptions[K]
  key: K
}

export interface GlassesProduct extends ProductV2 {
  coverLeft: Cover
  coverFront: Cover
  coverRight: Cover
  externalId?: string
  renderingOptions: GlassesRenderingOptions
  framingSize: string
  dataFilling?: boolean
}

export enum IntegrationType {
  TIENDANUBE = "TIENDANUBE",
  COMMON = "COMMON",
}

export enum UserStatusTypes {
  ACTIVE = "ACTIVE",
  COMMON = "COMMON",
  NEW = "NEW",
  DISABLED = "DISABLED",
}

export interface UserData {
  username: string
  password: string
  group: string
  merchantId: string
  integrationType: IntegrationType
}

export interface MerchantData {
  id: string
  name: string
  email: string
  domain: string
  planId: string
  cognitoSub: string
  description: string
  brandsIds: string[]
  token?: string
}

export type Brand = {
  id: string
  name: string
  slug: string
  sub?: string
}

export type MerchantId = string
